import { readGraftWebserviceUrl } from '@common/core/config/utils/read-graft-webservice-url.util'

export const isMembershipsServiceConfigured = () => Boolean(readGraftWebserviceUrl('MEMBERSHIPS'))
